<ng-template #expandedSectionTemplate let-estShown="estShown" let-section="section">
  @if (estShown) {
    <div class="section expanded">
      @if (section.canSearch) {
        <div class="inputwrapper">
          <input type="TEXT" [id]="'input_'+section.id" [name]="section.id" [placeholder]="placeholderForSection(section)" tabindex="0" (keyup)="sectionSearchKeyup($event, section)">
          <div class="nameclear" tabindex="0" [attr.aria-label]="clearStr" role="button" (click)="toggleSectionSearch(section, true, true)" (keydown.space)="toggleSectionSearch(section, true, true)" (keyup.enter)="toggleSectionSearch(section, true, true)"></div>
        </div>
      }
      <div class="sectionbody">
        @if (section.loading) {
          <div class="facet"><edx-spinner [mini]="true"></edx-spinner></div>
        }
        @if (!!section.items && !!section.items.length) {
          @for (item of section.items; track item) {
            <div class="facet" [ngClass]="{readonly:item.readOnly}">
              <input type="checkbox" [id]="facetKey(item)" (click)="facetClicked($event, item)" class="checkbox facetcb" tabindex="-1" [ngClass]="{checked: item.checked}">
              <span for [id]="facetKey(item)" role="checkbox" [attr.aria-label]="getAriaLabel(facetKeyName(item, section)+' '+facetValue(item)+' '+altLabels['facetItem'],item)" title="{{facetKeyName(item, section)}}" tabindex="0" [attr.aria-checked]="item.checked" (click)="facetClicked($event, item)" (keydown.space)="facetClicked($event, item)">{{facetKeyName(item, section)}}</span>
              @if (facetValue(item) !== -1) {
                <div class="facetcount">{{facetValue(item)}}</div>
              }
            </div>
          }
        }
        @if (!section.loading && (!section.items || !section.items.length)) {
          <div class="facet" tabindex="0" [attr.aria-label]="altLabels['noItems']">{{altLabels['noItems']}}</div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #sectionsTemplate let-stShown="stShown">
  @if (stShown) {
    @if (showReset() && ui>=2 && !!sections) {
      <button class="mobile secondary right top" [ngClass]="{readonly:disableReset(), oai:isAddin}" tabindex="0" (click)="reset()" (keydown.space)="reset()" (keyup.enter)="reset()" [disabled]="disableReset()">{{clearStr}}</button>
    }
    @for (section of sections; track section) {
      <div class="section">
        <div class="sectionheader">
          <div class="section-title" [tabindex]="!expandedSection?0:-1" [attr.aria-label]="altLabels['facet']+' '+section.title">{{section.title}}</div>
        </div>
        <div class="sectiontoggle" [ngClass]="{open:section.isOpen, closed:!section.isOpen}" [attr.aria-label]="getAriaLabelForExpander(section)" [attr.aria-expanded]="section.isOpen" role="button" [tabindex]="!expandedSection?0:-1" (click)="toggleSection(sections.indexOf(section))" (keydown.space)="toggleSection(sections.indexOf(section))"></div>
        @if (section.id!=='datefacets' && section.canSearch) {
          @if (section.isOpen && !section.isSearchOpen) {
            <div class="sectionsearch" [tabindex]="!expandedSection?0:-1" [attr.aria-label]="altLabels['searchFacet']" role="button" (click)="toggleSectionSearch(section, false)" (keydown.space)="toggleSectionSearch(section, false)"></div>
          }
          @if (section.isOpen && section.isSearchOpen) {
            <div class="inputwrapper">
              <input type="TEXT" [id]="'input_'+section.id" [name]="section.id" [placeholder]="placeholderForSection(section)" [tabindex]="!expandedSection?0:-1" (keyup)="sectionSearchKeyup($event, section)">
              <div class="nameclear" [tabindex]="!expandedSection?0:-1" role="button" [attr.aria-label]="clearStr" (click)="toggleSectionSearch(section, true)" (keydown.space)="toggleSectionSearch(section, true)" (keyup.enter)="toggleSectionSearch(section, true)"></div>
            </div>
          }
        }
        @if (section.isOpen || section.id==='datefacets') {
          <div class="sectionbody" [ngClass]="{edx_hidden:!section.isOpen, opening:section.isOpening, closing: section.isClosing}" (animationend)="animationComplete(section)">
            @if (section.id!=='datefacets') {
              @if (section.loading) {
                <div class="facet">
                  <edx-spinner [mini]="true"></edx-spinner>
                </div>
              }
              @if (!!section.items && !!section.items.length) {
                @for (item of section.items; track item; let i = $index) {
                  @if (!section.moreLess || section.moreShown || i<section.lessLen || item.checked) {
                    <div class="facet" [ngClass]="{readonly:item.readOnly}">
                      <input type="checkbox" [id]="facetKey(item)" (click)="facetClicked($event, item)" class="checkbox facetcb" tabindex="-1" [ngClass]="{checked: item.checked}">
                      <span for [id]="facetKey(item)" role="checkbox" [attr.aria-label]="getAriaLabel(facetKeyName(item, section)+' '+facetValue(item)+' '+altLabels['facetItem'],item)" title="{{facetKeyName(item, section)}}" [tabindex]="!expandedSection?0:-1" [attr.aria-checked]="item.checked" (click)="facetClicked($event, item)" (keydown.space)="facetClicked($event, item)">{{facetKeyName(item, section)}}</span>
                      @if (facetValue(item) !== -1) {
                        <div class="facetcount">{{facetValue(item)}}</div>
                      }
                    </div>
                  }
                }
                @if (!!section.moreLess) {
                  <div class="moreless" [attr.aria-label]="altLabels['showAllItems']" [tabindex]="!expandedSection?0:-1" (click)="toggleExpandedSection(section)" (keydown.space)="toggleExpandedSection(section)" (keyup.enter)="toggleExpandedSection(section)">{{section.moreLess}}</div>
                }
              }
              @if (!section.loading && (!section.items || !section.items.length)) {
                <div [tabindex]="!expandedSection?0:-1" [attr.aria-label]="altLabels['noItems']" class="facet">{{altLabels['noItems']}}</div>
              }
            }
            @if (section.id==='datefacets') {
              <edx-dynamic-form #dynamicform [ngClass]="{edx_hidden:!section.isOpen}" [formKind]="'profile_query_datefacets'" [layout]="formLayout" [formTemplate]="facetFormTemplate" [inDialog]="true" [desc]="desc" [controller]="this"></edx-dynamic-form>
            }
          </div>
        }
      </div>
    }
  }
</ng-template>

@if (ui<2 && isOpen) {
  <div class="sidebar-container" (keyup)="onKeyUp($event)">
    @if (!!expandedSection) {
      <div class="headerbody expanded">
        <div class="sidebar-header">
          <div class="sidebar-header-backarrow" id="edx_sidebar_header_arrow" tabindex="0" [attr.aria-label]="altLabels['backToFacets']" role="button" (click)="toggleExpandedSection(expandedSection)" (keydown.space)="toggleExpandedSection(expandedSection)"></div>
          <div class="sidebar-title">{{expandedSection.title}}</div>
        </div>
        <ng-container *ngTemplateOutlet="expandedSectionTemplate;context:{estShown:true,section:expandedSection}"></ng-container>
      </div>
    }
    <div class="headerbody" [ngClass]="{hidden:!!expandedSection, hiding:expandedSection&&expandedSection.isExpanding, showing:expandedSection&&expandedSection.isContracting}" (animationend)="animationComplete(expandedSection)">
      <div class="sidebar-header">
        <div class="sidebar-title" [tabindex]="!expandedSection?0:-1">{{title}}</div>
      </div>
      @if (!loading) {
        <div class="sidebar-content">
          @if (showFilters) {
            <div>
              @if (!canHaveFacets) {
                <edx-dynamic-form #dynamicform [formKind]="kind" [layout]="formLayout" [formTemplate]="formTemplate" [inDialog]="true" [desc]="desc" [controller]="this"></edx-dynamic-form>
              }
              <ng-container *ngTemplateOutlet="sectionsTemplate;context:{stShown:true}"></ng-container>
            </div>
          }
          @if (!showFilters || (canHaveFacets && !sections)) {
            <div>
              <div class="no-filters" tabindex="!expandedSection?0:-1">{{noFiltersStr}}</div>
            </div>
          }
          @if (showFilters) {
            <div>
              <div class="gradient-strip"></div>
            </div>
          }
        </div>
      }
    </div>
    <div class="sidebar-footer">
      <button [ngClass]="{readonly: okDisabled}" id="edx_filter_apply" tabindex="0" role="button" class="primary" [disabled]="okDisabled" (click)="search()">{{applyStr}}</button>
      <button class="secondary right" id="edx_filter_clear" tabindex="0" role="button" [ngClass]="{readonly:disableReset()}" (click)="reset()" [disabled]="disableReset()">{{clearStr}}</button>
    </div>
    @if (loading) {
      <edx-spinner></edx-spinner>
    }
  </div>
}
@if (ui>=2 && isOpen) {
  <edx-popup #formDialog [desc]="desc" [callback]="this" [kind]="kind" [title]="title" [ok]="applyStr" [okDisabled]="okDisabled">
    @if (!loading) {
      <div class="sidebar-container mobile">
        <div class="sidebar-content mobile">
          @if (showFilters) {
            @if (!canHaveFacets) {
              @if (showReset()) {
                <button class="mobile secondary right" tabindex="0" role="button" [ngClass]="{readonly:disableReset(), oai:isAddin}" (click)="reset()" [disabled]="disableReset()">{{clearStr}}</button>
              }
              <edx-dynamic-form #dynamicform [formKind]="formDialog.kind" [layout]="formLayout" [formTemplate]="formTemplate" [inDialog]="true" [data]="formDialog.formData" [desc]="formDialog.desc" [controller]="this"></edx-dynamic-form>
            }
            <ng-container *ngTemplateOutlet="sectionsTemplate;context:{stShown:true}"></ng-container>
          }
          @if (!showFilters || (canHaveFacets && !sections)) {
            <div class="no-filters" tabindex="0">{{noFiltersStr}}</div>
          }
        </div>
      </div>
    }
  </edx-popup>
  @if (loading) {
    <edx-spinner></edx-spinner>
  }
}